/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { MEDIA_RESOLUTIONS_string } from "@adapptio/lib-blueprint";
import { IMediaResolution, mediaResolutions } from "@adapptio/lib-components";
import {
	BASE_PREVIEW_RESOLUTION_ID,
	previewResolutions,
	PRINT_PREVIEW_RESOLUTION_ID,
	TPreviewResolutionId
} from "./previewResolutions";
import { isInRange, isNilOrEmptyString } from "@adapptio/lib-shared";

export function isMediaResolutionId(
	previewResolutionId: TPreviewResolutionId
): previewResolutionId is MEDIA_RESOLUTIONS_string {
	return mediaResolutions.has(previewResolutionId as MEDIA_RESOLUTIONS_string);
}

export function isBaseScreenResolutionId(previewResolutionId: TPreviewResolutionId): boolean {
	return previewResolutionId === BASE_PREVIEW_RESOLUTION_ID;
}

export function getPreviewResolutionById(previewResolutionId: TPreviewResolutionId): IMediaResolution {
	return previewResolutions.get(previewResolutionId);
}

export function getMediaResolutionIdForWidth(width: number): MEDIA_RESOLUTIONS_string {
	let fallbackMatch: MEDIA_RESOLUTIONS_string;

	for (const [ key, value ] of mediaResolutions) {
		if (key === PRINT_PREVIEW_RESOLUTION_ID) {
			continue;
		}

		const min = value.screenMin;
		const max = value.screenMax;

		if (isNilOrEmptyString(min) && isNilOrEmptyString(max)) {
			fallbackMatch = key;
			continue;
		}

		if (isNilOrEmptyString(min)) {
			if (width <= max) {
				return key;
			}
		}

		if (isNilOrEmptyString(max)) {
			if (width >= min) {
				return key;
			}
		}

		if (isInRange(min, max, width)) {
			return key;
		}
	}

	return fallbackMatch;
}
